import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Get the full URL for an image, handling various URL formats
 * - Filters out invalid/test URLs
 * - Adds API prefix for local uploads
 * - Handles absolute URLs
 * @param {string} url - The image URL (can be relative or absolute)
 * @returns {string|null} The full image URL or null if invalid
 */
export function getImageUrl(url) {
  if (!url) return null;
  
  // Skip invalid test/placeholder URLs
  const invalidPatterns = ['test.com', 'example.com', 'placeholder', 'via.placeholder'];
  if (invalidPatterns.some(pattern => url.includes(pattern))) {
    return null;
  }
  
  // Absolute URLs - return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Local uploads with /api prefix
  if (url.startsWith('/api/')) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  
  // Local uploads without prefix - add /api
  if (url.startsWith('/uploads/') || url.startsWith('uploads/')) {
    return `${process.env.REACT_APP_BACKEND_URL}/api${url.startsWith('/') ? '' : '/'}${url}`;
  }
  
  // Default - add /api prefix
  return `${process.env.REACT_APP_BACKEND_URL}/api${url.startsWith('/') ? '' : '/'}${url}`;
}

/**
 * Handle broken images by setting a fallback or hiding
 * Use as: onError={(e) => handleImageError(e, '/fallback.png')}
 */
export function handleImageError(event, fallbackSrc = null) {
  const img = event.target;
  img.onerror = null; // Prevent infinite loop
  
  if (fallbackSrc) {
    img.src = fallbackSrc;
  } else {
    // Hide the broken image
    img.style.display = 'none';
  }
}

